module.exports = __webpack_public_path__ + "img/home-card3.042dc343.svg";